import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";
import { Card, Form } from "react-bootstrap";
import Footer2 from "../components/Footer2";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { BASE_URL } from "../config/BaseUrls";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import leftArrow from "./image/moveimgarrow.png"; // Left arrow
import rightArrow from "./image/moveimgarrow.png";
import { useAuth } from "../context/auth";
import axios from "../AxiosInstance";
import toast from "react-hot-toast";
import { LanguageContext } from "../context/LanguageContext";

const books = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Crime",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book2.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book3.png"),
  },

  {
    image: require("../pages/image/book1.png"),
  },
  {
    image: require("../pages/image/book2.png"),
  },
  {
    image: require("../pages/image/book3.png"),
  },
  {
    image: require("../pages/image/book2.png"),
  },
  {
    image: require("../pages/image/book3.png"),
  },

  // Add more book data here as needed
];

const UserBooksAndReviews = () => {
  const { lg } = useContext(LanguageContext);

  const [selectedOptionsRead, setSelectedOptionsRead] = useState({});
  const [bookss, setBookss] = useState([]);
  const [bookssRead, setBookssRead] = useState([]);
  const [selectedImageLaed, setSelectedImageLaed] = useState(null);
  const fileInputRefLaed = useRef(null);
  const totalBooks = 8;
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(totalBooks, 8),
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    arrows: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(totalBooks, 3),
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: Math.min(totalBooks, 3),
          centerMode: false,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: Math.min(totalBooks, 2.1),
          centerMode: false,
          centerPadding: "25px",
        },
      },
    ],
  };

  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <img
        src={leftArrow}
        alt="Previous"
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          left: "-30px", // Adjust position
          top: "45%",
          transform: "translateY(-50%) rotate(180deg)", // Rotate left arrow
          width: "15px",
          height: "15px",
          cursor: "pointer",
          zIndex: 1, // Ensure it's above other elements
        }}
        onClick={(e) => {
          e.stopPropagation(); // Prevent default event bubbling
          if (typeof onClick === "function") {
            onClick();
          }
        }}
      />
    );
  };

  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <img
        src={rightArrow}
        alt="Next"
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          right: "-20px", // Adjust position
          top: "45%",
          transform: "translateY(-50%) rotate(0deg)",
          width: "15px",
          height: "15px",
          cursor: "pointer",
          zIndex: 1,
        }}
        onClick={(e) => {
          e.stopPropagation(); // Prevent default event bubbling
          if (typeof onClick === "function") {
            onClick();
          }
        }}
      />
    );
  };
  // your book array length

  const settingsd = {
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(totalBooks, 8),
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    arrows: totalBooks > 1, // show arrows only if more than 1 book
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    rtl: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: Math.min(totalBooks, 5.5),
        },
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: Math.min(totalBooks, 4.5),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(totalBooks, 3.8),
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: Math.min(totalBooks, 3.2),
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: Math.min(totalBooks, 2.2),
          centerMode: false,
          centerPadding: "20px",
          arrows: false,
        },
      },
      {
        breakpoint: 390,
        settings: {
          slidesToShow: Math.min(totalBooks, 2),
          arrows: false,
        },
      },
    ],
  };
  // Load the selected image from localStorage on component mount
  useEffect(() => {
    const storedImageLaed = localStorage.getItem("userProfileImage");
    if (storedImageLaed) {
      setSelectedImageLaed(storedImageLaed);
    }
  }, []);

  const handleButtonClickLaed = () => {
    if (fileInputRefLaed.current) {
      fileInputRefLaed.current.click();
    }
  };

  const handleFileChangeLaed = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImageLaed(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("userProfileImage", reader.result); // Save to localStorage
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  const navigate = useNavigate();

  const [visibleCard, setVisibleCard] = useState(null); // Tracks which card is visible

  const handleEditClick = (index) => {
    setVisibleCard(index); // Show the card corresponding to the clicked index
    setVisibleCard1(false);
  };

  const handleCancel = () => {
    setVisibleCard(null); // Hide the card
  };

  const [visibleCard1, setVisibleCard1] = useState(null); // Tracks which card is visible

  const handleEditClick1 = (index) => {
    setVisibleCard1(index); // Show the card corresponding to the clicked index
    setVisibleCard(false);
  };

  const handleCancel1 = () => {
    setVisibleCard1(null); // Hide the card
  };

  const [selectedOptions, setSelectedOptions] = useState({});

  // Load saved options from localStorage
  useEffect(() => {
    const savedOptions =
      JSON.parse(localStorage.getItem("selectedOptions")) || {};
    setSelectedOptions(savedOptions);
  }, []);

  const [auth, setAuth] = useAuth();

  const user = auth?.user; //

  // FAtch User Details

  const userId = auth?.user?._id;

  useEffect(() => {
    const fetchWantToReadBooks = async () => {
      try {
        const res = await axios.get(`api/v1/review/book-statuswent/${userId}`);
        console.log("Fetched books:", res.data); // 👈 Check what's actually returned
        setBookss(res.data);
      } catch (error) {
        console.error("Failed to fetch", error);
      }
    };

    fetchWantToReadBooks();
  }, [userId]);

  useEffect(() => {
    const fetchReadBooks = async () => {
      try {
        const res = await axios.get(`api/v1/review/book-statusread/${userId}`);
        console.log("Fetched books:", res.data); // 👈 Check what's actually returned
        setBookssRead(res.data);
      } catch (error) {
        console.error("Failed to fetch", error);
      }
    };

    fetchReadBooks();
  }, [userId]);

  // Load saved options from localStorage
  useEffect(() => {
    const savedOptionsRead =
      JSON.parse(localStorage.getItem("selectedOptionsRead")) || {};
    setSelectedOptionsRead(savedOptionsRead);
  }, []);

  // Save selected option to localStorage
  // const handleOptionChangeRead = (index, value) => {
  //   const updatedOptionsRead = { ...selectedOptionsRead, [index]: value };
  //   setSelectedOptionsRead(updatedOptionsRead);
  //   localStorage.setItem(
  //     "selectedOptionsRead",
  //     JSON.stringify(updatedOptionsRead)
  //   );
  // };

  const [users, setUsers] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`api/v1/auth/user-profile/${userId}`);
        setUsers(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);

  // FATCH REVIEWS BY USERID

  const [ratedBooks, setRatedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBook, setSelectedBook] = useState(null);

  useEffect(() => {
    const fetchRatedBooks = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `api/v1/review/recently-rated/${userId}`
        );
        setRatedBooks(response.data.books);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching rated books:", error);
        setLoading(false);
      }
    };

    fetchRatedBooks();
  }, [userId]);

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  const handleBookClick = (book) => {
    if (!book) return;
    console.log("Book clicked:", book);
   const selectedBookObj = {
      bookId: undefined, // 👈 Use book.id if available
      bookCoverImage: book.coverImage, // <== This is correct
      title: book.title,
      author: book.author,
      descriptions: book.aboutBook, // ✅ add this
      titless: book.title,
      publisher: book.publisher,
      book: book.bookId,// 👈 Use book.bookId._id if available
      EAN: book.EAN, // 👈 Add EAN if available
     
    };
    setSelectedBook(book);
    localStorage.setItem("selectedBookforreviews", JSON.stringify(selectedBookObj));
    localStorage.setItem("selectedBookforreviewsnew", JSON.stringify(selectedBookObj));

    // ✅ Prefer EAN if available, otherwise fallback to bookId
    const queryParam = book?.EAN
      ? `ean=${encodeURIComponent(book.EAN)}`
      : `bookid=${encodeURIComponent(book?.bookId?._id)}`;

    // ✅ Decide source flag
    const sourceParam = book?.review?.offilioBookId

      ? "offilio=true"
      : "searchbook=true";

    navigate(`/reviews?${queryParam}&${sourceParam}`);
  };


  const handleOptionChange = async (index, value) => {
    const book = bookss[index];
    const statusId = book?.statusId;

    if (!statusId) {
      console.warn("Status ID (statusId) missing");
      return;
    }

    if (value === "Remove") {
      await deleteBook(statusId);
      // Optionally, remove from local state
      const updatedBooks = [...bookss];
      updatedBooks.splice(index, 1);
      setBookss(updatedBooks);
      toast.success("Book Remove Successfully");
      handleCancel();
    } else {
      await updateStatus(statusId, value);
      toast.success(`Book status changed to "${value}" successfully.`);

      handleCancel();
      // 👇 Update selected option immediately
      setSelectedOptions((prev) => {
        const updatedOptions = {
          ...prev,
          [book.bookId]: value,
        };
        localStorage.setItem("selectedOptions", JSON.stringify(updatedOptions));
        return updatedOptions;
      });
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };

  const handleOptionChangeRead = async (index, value) => {
    const book = bookssRead[index];
    const statusId = book?.statusId;

    if (!statusId) {
      console.warn("Status ID (statusId) missing");
      return;
    }

    if (value === "Remove") {
      await deleteBook(statusId);
      // Optionally, remove from local state
      toast.success("Book Remove Successfully");

      const updatedBooks = [...bookssRead];
      updatedBooks.splice(index, 1);
      setBookssRead(updatedBooks);
      handleCancel1();
    } else {
      await updateStatus(statusId, value);

      toast.success(`Book status changed to "${value}" successfully.`);

      handleCancel1();
      setSelectedOptionsRead((prev) => {
        const updatedOptionsRead = {
          ...prev,
          [book.bookId]: value,
        };
        localStorage.setItem(
          "selectedOptionsRead",
          JSON.stringify(updatedOptionsRead)
        );
        return updatedOptionsRead;
      });
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };

  const updateStatus = async (statusId, newStatus) => {
    try {
      const res = await axios.put(`api/v1/review/${statusId}`, {
        status: newStatus,
      });
      console.log(res.data.message);
    } catch (err) {
      console.error("Update failed", err);
    }
  };

  const deleteBook = async (statusId) => {
    try {
      const res = await axios.delete(`api/v1/review/${statusId}`);
      console.log(res.data.message);
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  return (
    <>
      <div className="leaddashheader">
        <Header3 />
      </div>

      <div className="alincenterawidth">
        <div
          className="highyauto"
          style={{
            backgroundColor: "#F2F2F2",
            height: "185px",
            alignItems: "center",
          }}
        >
          <div
            className="d-md-flex  justzomag11   mlmrleading gap-xl-5 gap-4 "
            style={{ paddingTop: "30px" }}
          >
            <div className="textsmctrlead   ">
              {/* Header */}
              <div className="d-sm-flex  gap-2 gap-md-3 ">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRefLaed}
                  style={{ display: "none" }} // Hide the input
                  onChange={handleFileChangeLaed} // Handle file change
                />
                <img
                  src={
                    users?.profileImage
                      ? BASE_URL + "/uploads/" + users.profileImage
                      : require("../pages/image/addphotoicon.png")
                  } // Show user-selected image or default image
                  alt="Profile"
                  className="rounded-circle widimg "
                  width="105px"
                  height="105px"
                  style={{ width: "105px", height: "105px" }}
                //   style={{ width: "118px", height: "118px" }} // Set dimensions as needed
                // onClick={handleButtonClickLaed} // Allow clicking on the image to upload a new one
                />
                <div className="text-center text-sm-start d-flex align-items-center flex-column justify-content-center" >
                  <div
                    className=" mt-2 fw-bold fs-22 ftzpual text-dark "
                    style={{ lineHeight: "33.6px" }}
                  >
                    {user?.name}
                  </div>
                  {user?.isAmbassador && (
                    <>
                      <div
                        className="fw-normal ftzpual fs-22"
                        style={{ color: "#DF8244" }}
                      >
                        Ambassador
                      </div>
                      <div
                        className="fw600 fs-18 ftzpual  ftzgern"
                        style={{ color: "#2A2A2A" }}
                      >
                        {/* Level  */}
                        {lg?.level}1
                      </div>
                    </>)}
                </div>
              </div>
            </div>

            <div className=" mt-lg-4 mt-2 pt-sm-2 mx-lg-5 mlmreditbrns justify-content-center  d-flex flex-wrap gap-sm-4 gap-2">
              <button
                className="text-white rounded-1 fw-bold fs-18 btnedit2 ftzgern border-0 text-center"
                style={{
                  width: "153px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                }}
                onClick={() => navigate("/profile")}
              >
                {/* Edit Profile */}
                {lg?.editprf}
              </button>
              {/* OLD CODE - Future use: Ambassador conditional rendering */}
              {/* {user?.isAmbassador && (
                <>
                  <button
                    className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                    style={{
                      width: "180px",
                      height: "53px",
                      backgroundColor: "#34C3C9",
                      fontSize: "18px",
                      lineHeight: "18px",
                    }}
                    // onClick={handleShow} // Trigger modal on click
                    onClick={() => navigate("/booksdetails")}
                  >
                    {lg?.cbclub}
                  </button>
                  <button
                    className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                    style={{
                      width: "180px",
                      height: "53px",
                      backgroundColor: "#34C3C9",
                      fontSize: "18px",
                      lineHeight: "18px",
                    }}
                    onClick={() => navigate("./silentreading")} // Trigger modal on click
                  >
                    {lg?.cbsil}
                  </button>
                </>
              )} */}
              {/* NEW CODE: All users can create events */}
              <button
                className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                // onClick={handleShow} // Trigger modal on click
                onClick={() => navigate("/booksdetails")}
              >
                {/* CREATE <br /> BOOK CLUB */}
                {/* Create <br /> Book Club */}
                {lg?.cbclub}
              </button>
              <button
                className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                onClick={() => navigate("./silentreading")} // Trigger modal on click
              >
                {/* CREATE <br /> SILENT READING */}
                {/* Create <br /> Silent Reading */}
                {lg?.cbsil}
              </button>
              <button
                className="text-white rounded-1 fw-bold btneditmeet ftzgern  border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                onClick={() => navigate("/createmeetup")}
              >
                {/* CREATE <br /> BOOK DUO */}
                {/* Create
                <br /> Book Duo */}
                {lg?.cbduo}
              </button>
            </div>
          </div>
        </div>

        <div
          className="d-flex leadhight  justzomag11  leadflex leadjoin gap-lg-0 gap-1 w-100  text-uppercase"
          style={{ backgroundColor: "#A6A6A6", height: "59px" }}
        >

          <div
            className="px-lg-5 px-md-4 px-3 pt-3    ftzgern text-dark fw-bold fs-18 text-center  "
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/leading")}
          >
            I’m leading
          </div>

          <div
            className="px-lg-5 px-md-4 px-3 py-3  ftzgern text-dark fw-bold fs-18 text-center"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/dashboarduser")}
          >
            {/* I’M JOINING */}
            {lg?.joining}
          </div>

          <div
            className="px-lg-4 px-md-3 px-2 py-3   bg-white ftzgern text-dark fw-bold fs-18 text-center  "
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/booksandreviewsuser")}
          >
            {/* Books & reviews */}
            {lg?.bandrew}
          </div>
          {user?.isAmbassador && (
            <div
              className="px-md-3 px-sm-2 pt-3 ftzgern text-dark fw-bold fs-18 text-center"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/loyalty")}
            >
              {/* Loyalty programme */}
              {lg?.loyprog}
            </div>
          )}
        </div>

        <div>
          <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
            {/* Want to Read */}
            {lg?.rewbtn1}
          </div>

          <div className=" mlmrbookuser mlmrbookuser1 my-5  grrapbooks mt-3    gap-xl-2 ">
            <Slider {...settingsd}>
              {bookss.map((book, index) => (
                <Card
                  key={book?._id}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <Card.Img
                    className="imgsize1111aaa"
                    variant="top"
                    // src={book.image}
                    // src={`${BASE_URL}/uploadsbook/${book?.coverImage}`}
                    src={
                      book?.coverImage?.includes("/uploads/")
                        ? `${BASE_URL}${book.coverImage}` // for search/offilio books
                        : `${BASE_URL}/uploadsbook/${book.coverImage}` // for normal books
                    }
                    style={{
                      width: "119px",
                      height: "170px",
                      cursor: "pointer",
                    }}
                    // onClick={() => navigate("/reviews")}
                    onClick={() => handleBookClick(book)}
                  />
                  <Card.Body className="  p-0 mt-1 ">
                    <div>
                      <button
                        className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                        style={{
                          width: "122px",
                          height: "42px",
                        }}
                        onClick={() => {
                          console.log("BookID WENT READ ", book.bookId);
                          handleEditClick(index);
                        }}
                      >
                        Edit
                      </button>

                      {/* Conditional Content */}
                      <div
                        key={index}
                        className={`z-3 mt-2 p-2 oraginwid bg-white position-relative ${visibleCard === index ? "" : "d-none"
                          }`}
                        style={{
                          border: "1px solid #C1C1C1",
                          width: "180px",
                          height: "100px",
                        }}
                      >
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder   pt-1"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="want to read"
                                name={`group-${book.bookId}`}
                                type="radio"
                                id={`want-${book.bookId}`}
                                checked={
                                  selectedOptions[book.bookId] ===
                                  "Want to Read"
                                }
                                onChange={() =>
                                  handleOptionChange(index, "Want to Read")
                                }
                              />
                              <Form.Check
                                inline
                                label="read"
                                name={`group-${book.bookId}`}
                                type="radio"
                                id={`read-${book.bookId}`}
                                checked={
                                  selectedOptions[book.bookId] === "Read"
                                }
                                onChange={() =>
                                  handleOptionChange(index, "Read")
                                }
                              />
                              <Form.Check
                                inline
                                label="remove"
                                name={`group-${book.bookId}`}
                                type="radio"
                                id={`remove-${book.bookId}`}
                                checked={
                                  selectedOptions[book.bookId] === "Remove"
                                }
                                onChange={() =>
                                  handleOptionChange(index, "Remove")
                                }
                              />
                            </div>
                          ))}
                        </Form>
                        {/* <div
                        className="fw600 text-decoration-underline"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={handleCancel}
                      >
                        Cancel
                      </div> */}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ))}
              {/* </div> */}
              {/* <img
            src={require("./image/moveimgarrow.png")}
            width="8"
            height="18"
          /> */}
            </Slider>
          </div>

          {/* coursol */}
        </div>

        <div>
          <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
            {/* Read */}
            {lg?.Read}
          </div>

          <div className="d-sm-block d-none mlmrbookuser mlmrbookuser1 my-5  grrapbooks mt-3  justify-content-center  gap-xl-2 gap-1 align-items-center">
            <Slider {...settingsd}>
              {/* <img
              style={{ rotate: "180deg" }}
              src={require("./image/moveimgarrow.png")}
              width="8"
              height="18"
            /> */}
              {/* <div className="d-sm-block scalmin d-none  gap-2 my-5 "> */}
              {bookssRead.map((book, index) => (
                <Card
                  key={book?._id}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <Card.Img
                    className="imgsize1111aaa"
                    variant="top"
                    // src={book.image}
                    // src={`${BASE_URL}/uploadsbook/${book?.coverImage}`}
                    src={
                      book?.coverImage?.includes("/uploads/")
                        ? `${BASE_URL}${book.coverImage}` // for search/offilio books
                        : `${BASE_URL}/uploadsbook/${book.coverImage}` // for normal books
                    }
                    style={{
                      width: "119px",
                      height: "170px",
                      cursor: "pointer",
                    }}
                    // onClick={() => navigate("/reviews")}
                    onClick={() => handleBookClick(book)}
                  />
                  <Card.Body className=" p-0 mt-1  ">


                    <div>
                      <button
                        className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                        style={{
                          width: "122px",
                          height: "42px",
                        }}
                        onClick={() => handleEditClick1(index)}
                      >
                        Edit
                      </button>

                      {/* Conditional Content */}
                      <div
                        key={index}
                        className={`z-3 mt-2 p-2 oraginwid bg-white position-relative ${visibleCard1 === index ? "" : "d-none"
                          }`}
                        style={{
                          border: "1px solid #C1C1C1",
                          width: "180px",
                          height: "100px",
                        }}
                      >
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder   pt-1"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="want to read"
                                name={`group-${book.bookId}`}
                                type="radio"
                                id={`want-${book.bookId}`}
                                checked={
                                  selectedOptionsRead[book.bookId] ===
                                  "Want to Read"
                                }
                                onChange={() =>
                                  handleOptionChangeRead(index, "Want to Read")
                                }
                              />
                              <Form.Check
                                inline
                                label="read"
                                name={`group-${book.bookId}`}
                                type="radio"
                                id={`read-${book.bookId}`}
                                checked={
                                  selectedOptionsRead[book.bookId] === "Read"
                                }
                                onChange={() =>
                                  handleOptionChangeRead(index, "Read")
                                }
                              />
                              <Form.Check
                                inline
                                label="remove"
                                name={`group-${book.bookId}`}
                                type="radio"
                                id={`remove-${book.bookId}`}
                                checked={
                                  selectedOptionsRead[book.bookId] === "Remove"
                                }
                                onChange={() =>
                                  handleOptionChangeRead(index, "Remove")
                                }
                              />
                            </div>
                          ))}
                        </Form>
                        {/* <div
                        className="fw600 text-decoration-underline"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={handleCancel}
                      >
                        Cancel
                      </div> */}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ))}
              {/* </div> */}
              {/* <img
            src={require("./image/moveimgarrow.png")}
            width="8"
            height="18"
          /> */}
            </Slider>
          </div>
          {/* coursol */}
          <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
            <Slider {...settings}>
              {bookssRead.map((book, index) => (
                <div key={book?._id} className="d-flex justify-content-center">
                  <Card
                    key={book?._id}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsigggze"
                      variant="top"
                      // src={book.image}
                      // src={`${BASE_URL}/uploadsbook/${book?.coverImage}`}
                      src={
                        book?.coverImage?.includes("/uploads/")
                          ? `${BASE_URL}${book.coverImage}` // for search/offilio books
                          : `${BASE_URL}/uploadsbook/${book.coverImage}` // for normal books
                      }
                      style={{
                        width: "119px",
                        height: "170px",
                        cursor: "pointer",
                      }}
                      // onClick={() => navigate("/reviews")}
                      onClick={() => handleBookClick(book)}
                    />
                    <Card.Body className=" p-0 mt-1 ">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <button
                          className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                          style={{
                            width: "122px",
                            height: "42px",
                          }}
                          onClick={() => handleEditClick1(index)}
                        >
                          Edit
                        </button>

                        {/* Conditional Content */}
                        <div
                          key={index}
                          className={`z-3 mt-2 p-2 oraginwid bg-white position-relative ${visibleCard1 === index ? "" : "d-none"
                            }`}
                          style={{
                            border: "1px solid #C1C1C1",
                            width: "180px",
                            height: "100px",
                          }}
                        >
                          <Form>
                            {["radio"].map((type) => (
                              <div
                                key={`inline-${type}`}
                                className="fw-normal flxder   pt-1"
                                style={{ fontSize: "14px" }}
                              >
                                <Form.Check
                                  inline
                                  label="want to read"
                                  name={`group-${book.bookId}`}
                                  type="radio"
                                  id={`want-${book.bookId}`}
                                  checked={
                                    selectedOptionsRead[book.bookId] ===
                                    "Want to Read"
                                  }
                                  onChange={() =>
                                    handleOptionChangeRead(
                                      index,
                                      "Want to Read"
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="read"
                                  name={`group-${book.bookId}`}
                                  type="radio"
                                  id={`read-${book.bookId}`}
                                  checked={
                                    selectedOptionsRead[book.bookId] === "Read"
                                  }
                                  onChange={() =>
                                    handleOptionChangeRead(index, "Read")
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="remove"
                                  name={`group-${book.bookId}`}
                                  type="radio"
                                  id={`remove-${book.bookId}`}
                                  checked={
                                    selectedOptionsRead[book.bookId] ===
                                    "Remove"
                                  }
                                  onChange={() =>
                                    handleOptionChangeRead(index, "Remove")
                                  }
                                />
                              </div>
                            ))}
                          </Form>
                          {/* <div
                        className="fw600 text-decoration-underline"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={handleCancel}
                      >
                        Cancel
                      </div> */}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </Slider>
          </div>
        </div>

        <div>
          <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
            {/* Reviews */}
            {lg?.reviews}
          </div>

          <div className="d-sm-block d-none mlmrbookuser mlmrbookuser1 my-5  grrapbooks mt-3  justify-content-center  gap-xl-2 gap-1 align-items-center">

            {ratedBooks.length === 0 ? (
              <p className="text-center text-muted w-100 ">
                You Haven't rated any books yet.
              </p>
            ) : <Slider {...settingsd}>
              {
                ratedBooks.map((book, index) => (
                  <Card
                    key={book.bookId}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsizffe"
                      alt="booooksss"
                      variant="top"
                      // src={book.image}
                      // src={`${BASE_URL}/uploadsbook/${book?.coverImage}`}
                      src={
                        book?.coverImage?.includes("/uploads/")
                          ? `${BASE_URL}${book.coverImage}` // for search/offilio books
                          : `${BASE_URL}/uploadsbook/${book.coverImage}` // for normal books
                      }
                      style={{
                        width: "110px",
                        height: "160px",
                        cursor: "pointer",
                      }}
                      // onClick={() =>
                      //   navigate(`/reviews/?bookid=${book.bookId}`)
                      // }
                      onClick={() => handleBookClick(book)}
                    />
                    <Card.Body className=" p-0 mt-1">
                      <div>
                        <span
                          className="mx-2 text-warning "
                          style={{ fontSize: "21px" }}
                        >
                          {"★".repeat(book.rating)}
                          {"☆".repeat(5 - book.rating)}
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                ))
              }
            </Slider>}
          </div>

          {/* coursol */}
          <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">

            {ratedBooks.length === 0 ? (
              <p>You haven't rated any books yet.</p>
            ) : (
              <Slider {...settings}>{ratedBooks.map((book, index) => (
                <Card
                  key={book.bookId}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <Card.Img
                    className="imgsizffe"
                    variant="top"
                    // src={`${BASE_URL}/uploadsbook/${book?.coverImage}`}
                    src={
                      book?.coverImage?.includes("/uploads/")
                        ? `${BASE_URL}${book.coverImage}` // for search/offilio books
                        : `${BASE_URL}/uploadsbook/${book.coverImage}` // for normal books
                    }
                    style={{
                      width: "130px",
                      height: "170px",
                      cursor: "pointer",
                    }}
                    // onClick={() =>
                    //   navigate(`/reviews/?bookid=${book.bookId}`)
                    // }
                    onClick={() => handleBookClick(book)}
                  />
                  <Card.Body className=" p-0 mt-1">
                    <div>
                      <span
                        className="mx-2 text-warning "
                        style={{ fontSize: "21px" }}
                      >
                        {"★".repeat(book.rating)}
                        {"☆".repeat(5 - book.rating)}
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              )
              )}
              </Slider>)}
          </div>
        </div>
      </div>

      <div className="mt-5">
        <Footer2 />
      </div>
    </>
  );
};

export default UserBooksAndReviews;


